export function openSidebar() {
  if (typeof window !== 'undefined') {
    document.body.style.overflow = 'hidden';
    document.documentElement.style.setProperty('--SideNavigation-slideIn', '1');
  }
}

export function closeSidebar() {
  if (typeof window !== 'undefined') {
    document.documentElement.style.removeProperty('--SideNavigation-slideIn');
    document.body.style.removeProperty('overflow');
  }
}

export function toggleSidebar() {
  if (typeof window !== 'undefined' && typeof document !== 'undefined') {
    const slideIn = window
      .getComputedStyle(document.documentElement)
      .getPropertyValue('--SideNavigation-slideIn');
    if (slideIn) {
      closeSidebar();
    } else {
      openSidebar();
    }
  }
}

// Раздел чатов НЕ блокирует прокрутку страницы.
//
// Раньше обе функции трогали document.body.style.overflow, и это вешало
// приложение на телефоне: openMessagesPane ставил overflow:hidden при входе
// в раздел и ещё раз по кнопке «назад», а снять его было некому — вызов
// closeMessagesPane есть только в десктопной ветке. Хуже того, MUI-модалка
// при открытии ЗАПОМИНАЕТ текущий body.overflow и при закрытии возвращает
// его же — то есть возвращала 'hidden'. Страница переставала прокручиваться
// и после ухода из чатов.
//
// Блокировка тут и не нужна: раздел чатов меряет свою высоту сам и
// прокручивается внутри себя, а переписка на телефоне открывается модалкой,
// которая ставит свою блокировку и корректно её снимает.
export function openMessagesPane() {
  if (typeof window !== 'undefined') {
    document.documentElement.style.setProperty('--MessagesPane-slideIn', '1');
  }
}

export function closeMessagesPane() {
  if (typeof window !== 'undefined') {
    document.documentElement.style.removeProperty('--MessagesPane-slideIn');
  }
}

export function toggleMessagesPane() {
  if (typeof window !== 'undefined' && typeof document !== 'undefined') {
    const slideIn = window
      .getComputedStyle(document.documentElement)
      .getPropertyValue('--MessagesPane-slideIn');
    if (slideIn) {
      closeMessagesPane();
    } else {
      openMessagesPane();
    }
  }
}
